import React, { useContext, Fragment, useState, useEffect } from "react";
import { NavLink } from 'react-router-dom';
import { adres, findLokal, sortujLokale } from "../../../functions/ulice";
import { ikona } from '../../../functions/ikony';
import { usun_duplikaty } from '../../../functions/grupy';
import { isNumber, zl } from "../../../functions/utilities";
import { AuthContext } from "../../../Context/AuthProvider";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPrint } from '@fortawesome/free-solid-svg-icons'
import { useScroll } from "framer-motion";

const WspolnotaRozliczenieTBody = (props) => {

  const { idw, wspolnota, lokale, ulice, grupy, udzialyKontaAkt, stawki, przelewyWspolnota, czynszeWspolnota, czynszeMsc, mieszkancy, ind, zestaw } = props;

  const { role } = useContext(AuthContext);

  const [tablica, setTablica] = useState([]);

  const drukarka = (id_user, grupa_numer) => (                        
    <FontAwesomeIcon 
        icon={faPrint} 
        className='pointer'
        onClick={()=> {zestaw(id_user, grupa_numer)}}
    />
  )

  useEffect( () => {
    const temp = udzialyKontaAkt?.map( (udzial, i) => {

      const czynsz_temp = czynszeMsc?.find( czynsz => czynsz.id_user == udzial.id_user && czynsz.grupa_numer == udzial.grupa_numer);
      const czynsz = czynsz_temp ? czynsz_temp?.czynsz : null
      if (czynsz?.length == 0)
        return {}
      
      const mieszkaniec = mieszkancy.find( mieszkaniec => mieszkaniec.id_user == udzial.id_user);
      const id = role === "admin" ? ` (${mieszkaniec?.id_user}), grupa ${udzial?.grupa_numer}` : ``;
      
      const grupy_usera = grupy?.filter( g => g.id_user == mieszkaniec?.id_user && g.grupa_numer == udzial?.grupa_numer);
      const lokale_usera_temp = grupy_usera?.map( g => {
        return {
          id_lokal: g.id_lokal,
          id_user: g.id_user,
          grupa_numer: g.grupa_numer
        }
      });
      const lokale_usera = usun_duplikaty(lokale_usera_temp);
      const mieszkanie = findLokal(udzial, grupy_usera, lokale);

      return ({
        mieszkaniec,
        udzial,
        id,
        czynsz,
        czynsz_temp,
        grupy_usera,
        ind,
        lokale_usera,
        ulicaId: mieszkanie?.ulica,
        lokalNr: mieszkanie?.numer,
      });
    });
    setTablica(sortujLokale(temp));
  },[udzialyKontaAkt, mieszkancy, czynszeMsc ]);

  const tab = tablica?.map( (element, i) => {

    const { mieszkaniec, czynsz, lokale_usera, id, czynsz_temp, udzial } = element;

    const indy = ind?.map( (n,i) => {
      const indPoj = czynsz_temp?.ind?.find( c => c?.opis == n)?.kwota
      return (
        <td key={i}> {indPoj === undefined ? zl(0) : zl(indPoj) } </td> 
      )
    })
    
    const lokale_td = lokale_usera?.map( (lokal, i) => {
      return (
        <li key={i} className="left" >
          {
            role === "admin" ? (
              <NavLink 
                to={`/mieszkancy/rozliczenia?id=${lokal?.id_user}&idw=${idw}&g=${lokal?.grupa_numer}`}
                style={{
                  justifyContent: "initial"
                }}
                state={
                  {
                    from: {
                      czynszeMieszkaniec: czynszeWspolnota?.find( t => t.id_user == lokal.id_user),
                      przelewyMieszkaniec: przelewyWspolnota?.find( t => t.id_user == lokal?.id_user && t.nr_grupyUdzial == lokal.grupa_numer)?.przelewy,
                      wspolnota,
                      stawki
                    }
                  }
                }
              > 
                {ikona(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.rodzaj)} &nbsp; {`${adres(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.ulica, ulice, lokal.id_lokal, lokale) }`} 
              </NavLink>
            ) : (
              <Fragment>
                {ikona(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.rodzaj)} &nbsp; {`${adres(lokale?.filter( l => l.id === lokal.id_lokal )[0]?.ulica, ulice, lokal.id_lokal, lokale)}`} 
              </Fragment>
            )
          }
        </li>
      )
    })

    return (
        czynsz && <tr key={i}>
          <td className="left">
            {`${mieszkaniec?.imie_nazwisko}${id}`} 
          </td>
          <td>
            <ul style={{"listStyle": "none"}}>
              {lokale_td}
            </ul>
          </td>
            { stawki?.czy_eksploatacja == 1 ? (<td>{zl(czynsz.eksploatacja)}</td>) : ""   }
            { stawki?.czy_garaz == 1 ? (<td>{zl(czynsz.garaz)}</td>) : ""}
            { stawki?.czy_garaz_eksploatacja == 1 ? (<td>{zl(czynsz.garaz_eksploatacja)}</td>) : ""}
            { stawki?.czy_strych == 1 ? (<td>{zl(czynsz.strych)}</td>) : "" }
            { stawki?.czy_komorka ==  1 ? (<td>{zl(czynsz.komorka)}</td>) : "" }
            { stawki?.czy_utrzymanie_czystosci == 1 ? (<td>{zl(czynsz.utrzymanie_czystosci)}</td>) : ""} 
            { stawki?.czy_wywoz_smieci == 1 ? (<td>{zl(czynsz.wywoz_smieci)}</td>) : ""} 
            { stawki?.czy_fundusz_remontowy == 1 ? (<td>{zl(czynsz.fundusz_remontowy)}</td>) : ""} 
            { stawki?.czy_konserw_domofonu == 1 ? (<td>{zl(czynsz.konserw_domofonu)}</td>) : ""} 
            { stawki?.czy_konserw_windy == 1 ? (<td>{zl(czynsz.konserw_windy)}</td>) : ""} 
            { stawki?.czy_opl_za_adm == 1 ? (<td>{zl(czynsz.opl_za_adm)}</td>) : ""} 
            { stawki?.czy_abonament_cw == 1 ? (<td>{zl(czynsz.abonament_cw)}</td>) : ""} 
            { stawki?.czy_co == 1 ? (<td>{zl(czynsz.co)}</td>) : ""} 
            { stawki?.czy_energia_el_lokalu == 1 ? (<td>{zl(czynsz.energia_el_lokal)}</td>) : ""} 
            { stawki?.czy_ryczalt_gaz == 1 ? (<td>{zl(czynsz.ryczalt_gaz)}</td>) : ""} 
            { stawki?.czy_zagosp_terenu == 1 ? (<td>{zl(czynsz.zagosp_teren)}</td>) : ""} 
            { stawki?.czy_antena == 1 ? (<td>{zl(czynsz.antena)}</td>) : ""} 
            { stawki?.czy_ciepla_woda == 1 ? (<td>{zl(czynsz.ciepla_woda)}</td>) : ""} 
            { stawki?.czy_zimna_woda == 1 ? (<td>{zl(czynsz.zimna_woda)}</td>) : ""} 
            {
              <Fragment>
                {indy}
              </Fragment>
            }
            {
              czynsz_temp?.wodaMOpis && (<td>{zl(czynsz_temp?.wodaM)}</td>)
            }
          <td>{zl(czynsz.czynsz_na_msc + czynsz_temp?.wodaM)}</td>
          <td>{drukarka(mieszkaniec?.id_user, udzial.grupa_numer)}</td>
        </tr>
    )
  })
  return (
    <tbody>
      {tab}
    </tbody>
  )
}

export default WspolnotaRozliczenieTBody;